import { ref, watch, onMounted, onBeforeUnmount, type Ref } from 'vue';
import { useRequestTrackerStore } from '../stores/requestTracker';

export function useTrackedVideo(videoRef: Ref<HTMLVideoElement | null>, src: Ref<string | undefined>) {
  console.log('useTrackedVideo: call', {
 video: videoRef.value,
src: src.value,
});
  const store = useRequestTrackerStore();
  const requestId = ref<string | null>(null);

  const updateProgress = () => {
    const video = videoRef.value;
    console.log('useTrackedVideo: updateProgress', {
 video,
requestId: requestId.value,
buffered: video?.buffered.length ?? -1,
duration: video?.duration,
});
    if (!video || !video.duration || !video.buffered.length) return;

    const lastRange = video.buffered.end(video.buffered.length - 1);
    const progress = Math.min((lastRange / video.duration) * 100, 100);

    if (requestId.value) {
      store.updateRequest(requestId.value, { progress });
    }
  };

  const handleMetadata = () => {
    console.log('useTrackedVideo: handleMetadata');
    // Duration now available
    updateProgress();
  };

  const handleProgress = () => {
    console.log('useTrackedVideo: handleProgress');
    updateProgress();
  };

  const handleCanPlayThrough = () => {
    console.log('useTrackedVideo: handleCanPlayThrough');
    if (requestId.value) {
      cleanupListeners();
      store.updateRequest(requestId.value, { progress: 100 });
      store.finishedRequest(requestId.value, new Response(null, { status: 200 }));
    }
  };

  const handleError = () => {
    console.log('useTrackedVideo: handleError');
    if (requestId.value) {
      cleanupListeners();
      store.failedRequest(requestId.value, new Error('Video failed to load'));
    }
  };

  const startTracking = (url: string) => {
    const id = `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
    requestId.value = id;
    console.log('useTrackedVideo: startTracking', {
 url,
id,
});

    store.addRequest({
      type: 'video',
      id,
      url: new URL(url, location.href),
      method: 'GET',
      state: 'pending',
      progress: 0,
    });
  };

  const cleanupListeners = () => {
    const video = videoRef.value;
    if (!video) return;

    video.removeEventListener('loadedmetadata', handleMetadata);
    video.removeEventListener('progress', handleProgress);
    video.removeEventListener('canplaythrough', handleCanPlayThrough);
    video.removeEventListener('error', handleError);
  };

  onMounted(() => {
    console.log('useTrackedVideo: onMounted', {
 video: videoRef.value,
src: src.value,
});
    watch(
      [src, videoRef],
      ([newSrc, newRef], [oldSrc, oldRef]) => {
        console.log('useTrackedVideo: watch', {
 newSrc,
requestId: requestId.value,
oldSrc,
oldRef,
video: videoRef.value,
src: src.value,
});

        cleanupListeners();

        if (!newSrc || !videoRef.value) return;

        startTracking(newSrc);

        const video = videoRef.value;
        video.addEventListener('loadedmetadata', handleMetadata);
        video.addEventListener('progress', handleProgress);
        video.addEventListener('canplaythrough', handleCanPlayThrough);
        video.addEventListener('error', handleError);
      },
      { immediate: true },
    );
  });

  onBeforeUnmount(() => {
    console.log('useTrackedVideo: onBeforeUnmount', {
 video: videoRef.value,
src: src.value,
requestId: requestId.value,
});
    cleanupListeners();
    if (requestId.value) {
      store.removeRequest(requestId.value);
    }
  });
}
